import { render, staticRenderFns } from "./cardTransactionList.vue?vue&type=template&id=b3bfbf4e&scoped=true"
import script from "./cardTransactionList.vue?vue&type=script&lang=js"
export * from "./cardTransactionList.vue?vue&type=script&lang=js"
import style0 from "./cardTransactionList.vue?vue&type=style&index=0&id=b3bfbf4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3bfbf4e",
  null
  
)

export default component.exports